/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


$(document).ready(function(){
  $(document).on('click','.precheckout-btn', function(){
    $(this).parents('form').find('.cart-popup').addClass('show');
  })
  $(document).on('click','.popup-overlay', function(){
    $(this).parent().removeClass('show');
  });

  $(document).on('submit','form[action="/cart"]', function(e){
    const checkbox = $(this).find("input[type='checkbox']");
    if (!checkbox.is(":checked") && checkbox.length) {
      if (!this.checkValidity()) {
        e.preventDefault();
        checkbox.focus();
      }
    }
  });
  const images = document.querySelectorAll('img');
  images.forEach(img => {
    img.onerror = function() {
      this.style.display = 'none';
    };
  });

});